import { SVGProps } from "react";

export const FilterIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 12"
      {...props}
    >
      <path
        fill="#383838"
        d="M.563 3.368h8.564a2.624 2.624 0 0 0 2.558 2.057c1.252 0 2.3-.882 2.559-2.057h3.194a.563.563 0 0 0 0-1.125h-3.194A2.627 2.627 0 0 0 11.685.186c-1.25 0-2.3.882-2.558 2.057H.562a.563.563 0 0 0 0 1.125zm9.628-.561V2.8a1.497 1.497 0 0 1 1.494-1.49c.82 0 1.491.667 1.495 1.488v.009A1.496 1.496 0 0 1 11.685 4.3a1.496 1.496 0 0 1-1.494-1.491v-.002zm7.246 5.825H8.873a2.624 2.624 0 0 0-2.558-2.057c-1.252 0-2.3.882-2.559 2.057H.563a.563.563 0 0 0 0 1.125h3.193a2.627 2.627 0 0 0 2.559 2.057c1.25 0 2.3-.882 2.558-2.057h8.565a.563.563 0 0 0 0-1.125zm-9.628.561V9.2a1.497 1.497 0 0 1-1.494 1.49c-.82 0-1.491-.667-1.495-1.488v-.009A1.496 1.496 0 0 1 6.315 7.7c.823 0 1.492.669 1.494 1.491v.002z"
      />
    </svg>
  );
};
